import styled from 'styled-components';

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export default FormGroup;
